// this is the view for the depricated ldi estimated delivery
const Backbone = require('backbone'),
	EstDeliveryView = Backbone.View.extend({
		initialize: function() {
			this.listenTo(Backbone, 'finish:clicked', this.render);
			this.listenTo(Backbone, 'finish:hover', this.render);
		},

		el: '.js-est-delivery',

		render: function(data) {
			const preText = window.BCOM.device.isDesktop ? '' : 'Est Delivery: ';
			this.$el.html(preText.concat(data.estDeliveryDate));
		}
	});
module.exports = EstDeliveryView;
